
import React from 'react';
import MainContent from '@/components/home/MainContent';

const Index = () => {
  
  return (
    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-4 pt-8 relative">
      {/* Main content */}
      <MainContent showSearchOnly={false} />
    </div>
  );
};

export default Index;
